import { SvgIconProps } from '@traba/types'

export default function Refresh({
  size,
  color = '#7A8A99',
  strokeWidth = 1.5,
  ...props
}: SvgIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M14 8.10169C14 11.3592 11.3137 14 8 14C4.68629 14 2 11.3592 2 8.10169C2 4.84415 4.66667 2.20339 8 2.20339C12 2.20339 14 5.48022 14 5.48022M14 5.48022L14 2M14 5.48022H10.8966"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
